<!-- Main Content Container -->
<div class="flex flex-col min-h-0 space-y-6">
    @if (loading) {
    <div class="flex items-center justify-center bg-white rounded shadow p-10">
        <div class="text-center">
            <lucide-icon class="w-12 h-12 mx-auto mb-4 animate-spin text-primary" [img]="Loader"></lucide-icon>
            <p class="text-gray-600">Loading Public Profile...</p>
        </div>
    </div>
    }
    <div *ngIf="profileUpdateRequired" class="p-4 bg-yellow-100 text-yellow-800 rounded">
        Your public profile is due for an update. Last updated: {{ lastUpdated | date : "short" }}.
    </div>

    <!-- Page Header Section -->
    @if (!loading) {
    <section class="flex flex-col p-6 space-y-5 bg-white rounded shadow md:p-8">
        <h1 class="text-2xl font-bold md:text-3xl">{{ type }} Public Profile Management</h1>

        <div class="flex flex-col gap-5 mb-5">
            <div class="relative w-auto">
                <div class="flex flex-row w-auto justify-start items-center gap-8 m-0">
                    <label class="text-sm font-medium text-gray-700">
                        {{ type == "Investee" ? type + " Code" : "Corporate Name" }}
                    </label>
                    <div class="relative flex items-center w-auto">
                        <span #mirror class="absolute invisible whitespace-pre font-medium text-sm">
                            {{ code }}
                        </span>
                        <app-input
                            id="code"
                            class="w-auto"
                            [inputStyle]="{ 'width.px': Math.min(Math.max(mirror.offsetWidth + 80, 100), 1000) }"
                            [inputClass]="
                                'max-w-2xl border-2 border-primary p-2 py-2 pr-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all duration-200'
                            "
                            placeholder="{{ type }} id"
                            [value]="code"
                            [readonly]="true"
                            [style.width.px]="Math.min(Math.max(mirror.offsetWidth + 80, 100), 1000)"
                        >
                        </app-input>
                    </div>
                </div>
            </div>
        </div>

        <fieldset class="p-6 mb-6 border border-gray-300 rounded bg-white">
            <legend class="px-2 text-lg font-semibold">Public Profile</legend>

            <div class="bg-gray-50 border border-gray-300 rounded p-4">
                <form [formGroup]="form">
                    <app-quill-editor
                        formControlName="content"
                        [placeholder]="isOwner ? 'Write something...' : ''"
                        [maxLength]="500"
                        [hideToolbar]="true"
                        containerClass="border-primary text-black border-2 transition-all duration-200"
                    ></app-quill-editor>
                </form>

                <div class="flex flex-row justify-between items-end mt-4">
                    <h4 class="text-md">Profile Last Updated: {{ lastUpdated }}</h4>
                </div>
            </div>
        </fieldset>
    </section>
    }
</div>

<ng-template #updateProfileModal let-onConfirmRequest="onConfirmRequest" let-onClose="onClose">
    <div class="w-full max-w-xl p-4">
        <p class="mb-4 text-gray-700">
            Your profile was last updated on <strong>{{ lastUpdated }}</strong
            >. Please confirm <br />if your profile details are still up to date.
        </p>
        <div class="flex justify-end gap-2">
            <button
                type="button"
                class="px-5 py-2.5 text-white bg-red-600 rounded hover:bg-red-700"
                (click)="onConfirmRequest()"
            >
                Update Public Profile
            </button>
            <button
                type="button"
                class="px-5 py-2.5 text-gray-700 bg-gray-200 rounded hover:bg-gray-300"
                (click)="onClose()"
            >
                Profile is up to date
            </button>
        </div>
    </div>
</ng-template>
